import { OdataManager } from '@/api/odata/odata-manager';
import { Register_Line } from '@/api/model/interfaces';

export default class RegisterLineOdata extends OdataManager<Register_Line> {}
